"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReactWrapper = exports.mapOnClickToButton = exports.getComponentConfig = exports.camelHyphenateMap = exports.formulateClassNames = exports.resetClassName = exports.getEventMapping = void 0;
const react_1 = __importStar(require("react"));
const wrapper_config_1 = __importDefault(require("@iress/ids-react-wrapper-config/dist/wrapper.config"));
const stencil_docs_export_1 = __importDefault(require("@iress/ids-react-wrapper-config/dist/stencil-docs-export"));
const use_custom_element_1 = require("@iress/use-custom-element");
const slot_translation_1 = require("./slot-translation");
const helpers_1 = require("./utils/helpers");
const getEventMapping = (events, eventMap) => {
    const reactEventName = (event) => {
        if (eventMap && eventMap[event]) {
            return eventMap[event];
        }
        return event.replace('iress', 'on');
    };
    return events.map((event) => ({
        reactProp: reactEventName(event.event),
        wcProp: event.event,
        event: true,
    }));
};
exports.getEventMapping = getEventMapping;
const resetClassName = (prevEl, prevClass) => {
    const prevElClass = [];
    const prevClassArr = [];
    prevClass.split(' ').forEach((name) => prevClassArr.push(name));
    prevEl.className.split(' ').forEach((name) => prevElClass.push(name));
    if (prevClassArr.length > 0 && prevElClass.length > 0) {
        prevClassArr.forEach((name) => {
            const i = prevElClass.indexOf(name);
            if (i > -1)
                prevElClass.splice(i, 1);
        });
    }
    return prevElClass;
};
exports.resetClassName = resetClassName;
const formulateClassNames = (className, prevClassName, prevRef) => {
    let resetClassArr = [];
    if (prevClassName.current && prevRef.current) {
        resetClassArr = (0, exports.resetClassName)(prevRef.current, prevClassName.current);
    }
    else if (prevRef.current) {
        resetClassArr = prevRef.current.className.split(' ');
    }
    const newClassNames = [];
    if (className)
        className.split(' ').forEach((name) => newClassNames.push(name));
    return [...newClassNames, ...resetClassArr];
};
exports.formulateClassNames = formulateClassNames;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const camelHyphenateMap = (props) => {
    const propMap = [];
    Object.keys(props).forEach((prop) => {
        const hypenProp = (0, helpers_1.camelToHyphenated)(prop);
        if (prop !== hypenProp) {
            propMap.push({
                reactProp: prop,
                wcProp: hypenProp,
            });
        }
    });
    return propMap;
};
exports.camelHyphenateMap = camelHyphenateMap;
const getComponentConfig = (tagName) => wrapper_config_1.default.components.filter((item) => item.name === tagName)[0]
    ? wrapper_config_1.default.components.filter((item) => item.name === tagName)[0]
    : {};
exports.getComponentConfig = getComponentConfig;
const mapOnClickToButton = (applyButtonProp, 
// eslint-disable-next-line @typescript-eslint/ban-types
onClick, button) => {
    const buttonProp = {};
    if ((applyButtonProp === true && onClick !== undefined) ||
        button !== undefined) {
        buttonProp['button'] = true;
    }
    return buttonProp;
};
exports.mapOnClickToButton = mapOnClickToButton;
const createReactWrapper = (
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
TagName, // eslint-disable-line @typescript-eslint/no-explicit-any
shadow, suffix) => {
    var _a;
    // Get config
    const componentConfig = (0, exports.getComponentConfig)(TagName.replace(suffix, ''));
    const componentDocsData = stencil_docs_export_1.default.filter((config) => config.name + suffix === TagName);
    const componentEvents = (_a = componentDocsData[0]) === null || _a === void 0 ? void 0 : _a.events;
    const advancedEventNameMap = componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.advancedEventNameMapping;
    const preserveMarkup = componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.preserveMarkup;
    const preserveObjs = componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.preserveProps;
    const ReactWrapper = (_a) => {
        var { children, wcref, className, style, button } = _a, otherProps = __rest(_a, ["children", "wcref", "className", "style", "button"]);
        const prevClassName = (0, react_1.useRef)();
        const prevRef = (0, react_1.useRef)();
        (0, react_1.useEffect)(() => {
            prevClassName.current = className;
            prevRef.current = ref.current;
        });
        const formulatedClass = (0, exports.formulateClassNames)(className, prevClassName, prevRef);
        const buttonProp = (0, exports.mapOnClickToButton)(componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.mapOnClickToButton, otherProps.onClick, button);
        const propMap = (0, exports.camelHyphenateMap)(otherProps);
        const eventMapping = (0, exports.getEventMapping)(componentEvents, advancedEventNameMap);
        const propMapping = [
            ...propMap.filter((a) => {
                return !eventMapping.find((b) => {
                    return a.reactProp === b.reactProp;
                });
            }),
            ...eventMapping,
        ];
        const [customElementProps, ref] = (0, use_custom_element_1.useCustomElement)(otherProps, propMapping, preserveObjs, wcref);
        const wcAttrs = {
            class: formulatedClass.join(' '),
            style,
            ref,
        };
        return (react_1.default.createElement(TagName, Object.assign({}, customElementProps, buttonProp, wcAttrs), shadow || preserveMarkup
            ? children
            : (0, slot_translation_1.slotTranslation)(children)));
    };
    return ReactWrapper;
};
exports.createReactWrapper = createReactWrapper;
//# sourceMappingURL=create-react-wrappers.js.map